/*!
=========================================================
* Regiform IMS Frontend - Button Component
=========================================================
* Common button component with consistent styling
* Built with Ant Design Button, provides standardized props
=========================================================
*/
import { Button as AntButton } from "antd";
import PropTypes from "prop-types";
import "./Button.css";

function Button({
  children,
  type = "default",
  size = "middle",
  disabled = false,
  loading = false,
  icon,
  onClick,
  className = "",
  style = {},
  variant = "default", // custom variant for additional styling
  ...otherProps
}) {
  // Determine the CSS class based on variant
  const getVariantClass = () => {
    switch (variant) {
      case "clear":
        return "common-button-clear";
      case "refresh":
        return "common-button-refresh";
      case "primary":
        return "common-button-primary";
      case "danger":
        return "common-button-danger";
      default:
        return "common-button-default";
    }
  };

  return (
    <AntButton
      type={type}
      size={size}
      disabled={disabled}
      loading={loading}
      icon={icon}
      onClick={onClick}
      className={`common-button ${getVariantClass()} ${className}`}
      style={style}
      {...otherProps}
    >
      {children}
    </AntButton>
  );
}

Button.propTypes = {
  children: PropTypes.node,
  type: PropTypes.oneOf(["default", "primary", "ghost", "dashed", "link", "text"]),
  size: PropTypes.oneOf(["large", "middle", "small"]),
  disabled: PropTypes.bool,
  loading: PropTypes.bool,
  icon: PropTypes.node,
  onClick: PropTypes.func,
  className: PropTypes.string,
  style: PropTypes.object,
  variant: PropTypes.oneOf(["default", "clear", "refresh", "primary", "danger"]),
};

export default Button;
